/* eslint-disable no-multi-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-extraneous-class */
export default class HTMLElementInput {
  public static setTextInputEvents(
    element: HTMLInputElement,
    onEnterKey?: (e: HTMLInputElement) => void,
    restrictRegEx?: RegExp,
    editColor?: string,
  ): void {
    let initialColor: string | null = null;
    let initialValue: string | null = null;
    // actions on key press
    // eslint-disable-next-line no-param-reassign
    element.onpaste =
      element.oncut =
      element.onkeypress =
      element.onkeyup =
        (e: KeyboardEvent | ClipboardEvent | Event): boolean => {
          if (initialValue === null) {
            // set initial field color, text
            initialValue = element.value;
            initialColor = element.style.color;
          }
          const currentString = element.value || '';
          let testString = '';

          if (e instanceof KeyboardEvent) {
            const keyCode = e.which ? e.which : e.keyCode;
            if (e.type === 'keyup' && keyCode === 13) {
              // reset initial value + editing color on enter key / submit
              if (initialColor !== null) {
                element.style.color = initialColor;
                initialValue = null;
              }
              if (onEnterKey) onEnterKey(element);
              return false;
            }

            if (e.type === 'keypress') {
              testString = currentString + String.fromCharCode(keyCode);
            } else {
              testString = currentString;
            }
          } else if (e instanceof ClipboardEvent) {
            if (element instanceof HTMLTextAreaElement) {
              const pastedText = e.clipboardData ? e.clipboardData.getData('text') : '';
              testString =
                currentString.substring(0, element.selectionStart) +
                pastedText +
                currentString.substring(element.selectionEnd);
            }
          }

          if (restrictRegEx && testString !== currentString) {
            restrictRegEx.lastIndex = 0;
            const testPassed = restrictRegEx.test(testString) || testString.length === 0;
            if (!testPassed) return false;
          }

          // set editing color
          if (editColor) {
            if (initialColor && initialValue === element.value) element.style.color = initialColor;
            else element.style.color = editColor;
          }
          return true;
        };
  }
}
